import React from "react";
import { useAuth } from "./common/Auth";
import { useCollection } from "./context/AdminContext"; // reuse for agent users

const Agent = () => {
	const currentUser = useAuth();
	const { collection: agentUsers = [] } = useCollection('users', 10); // simplistic

	return (
		<div className="p-4 sm:p-6 max-w-5xl mx-auto">
			<h1 className="text-2xl font-semibold tracking-tight mb-2">Agent Portal</h1>
			<p className="text-sm text-gray-500">Tools for managing assigned systems and users.</p>

			<div className="mt-6 bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 p-5">
				<h3 className="font-semibold mb-3">Assigned Users</h3>
				<div className="text-sm space-y-1">
					{agentUsers.length > 0 ? agentUsers.map(u => (
						<div key={u.uid} className="p-2 bg-gray-50 dark:bg-gray-800 rounded flex justify-between">
							<span>{u.first} {u.last}</span>
							<span className="text-xs text-gray-500">{u.email}</span>
						</div>
					)) : <div className="text-gray-500">No assigned users loaded.</div>}
				</div>
				<div className="mt-4 text-xs text-gray-400">Logged in as: {currentUser?.email}</div>
			</div>
		</div>
	);
}

export default Agent;